var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 1175,
    viewBox: "0 0 430 1175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 1175,
    fill: "#191D21"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_7862)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.235 286.886C160.893 291.978 150 307.851 150 322.118V929.882C150 944.149 160.893 960.021 174.235 965.113L589.962 1123.95C603.269 1129.04 614.197 1121.55 614.197 1107.27V144.741C614.197 130.466 603.269 122.959 589.962 128.06L174.235 286.886ZM510.358 946.493C510.358 960.759 499.254 968.678 485.78 964.051L271.606 890.981C258.088 886.372 247.028 870.929 247.028 856.645V395.363C247.028 381.079 258.088 365.602 271.606 361.001L485.78 287.957C499.289 283.366 510.358 291.285 510.358 305.516V946.493Z",
    fill: "#B39D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.322 645.187C562.322 650.823 550.63 655.441 536.349 655.441H221.775C207.503 655.441 195.811 650.823 195.811 645.187C195.811 639.551 207.503 634.924 221.775 634.924H536.349C550.63 634.924 562.322 639.542 562.322 645.187Z",
    fill: "#B39D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.053 942.727C373.189 942.727 368.396 931.015 368.396 916.74V279.846C368.396 265.562 373.189 253.859 379.053 253.859C384.916 253.859 389.77 265.562 389.77 279.846V916.74C389.77 931.015 384.907 942.727 379.053 942.727Z",
    fill: "#B39D5D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_7862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 890,
    fill: "white",
    transform: "translate(150 181)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMobile);
export default __webpack_public_path__ + "static/media/footer-mobile.5bb3c84c83bcfb1e8856794e2ea107c0.svg";
export { ForwardRef as ReactComponent };